<template>
  <div class="p-2">
    <form method="post" action="javascript:void(0)" @submit="saveForm()">
      <h3 class="text-lg font-medium">{{ header }}</h3>
      <div class="uk-margin" v-for="input in inputs">
        <label>{{ input.label }}</label>
        <input
          class="uk-input focus-input"
          v-model="form[input.name]"
          type="text"
        />
      </div>
      <div slot="footer" class="flex space-x-2">
        <div class="global-button" @click="edit = false">İptal</div>
        <button type="submit" class="primary-button">
          Kaydet
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import HttpService from "../../services/http";
export default {
  name: "inline-add-form",
  props: {
    header: String,
    inputs: Array,
    table: String,
  },
  data() {
    return {
      form: {},
      edit: false,
      type: "insert",
    };
  },
  created() {},
  methods: {
    saveForm() {
      HttpService.inlineSave({
        table: this.table,
        type: this.type,
        inputs: this.form,
      }).then((resp) => {
        if (resp.data.success) {
          this.edit = false;
          this.form = {};
          this.$emit("after", "success");
          this.$emit("hide", true);
        }
      });
    },
  },
};
</script>

<style>
.flex {
  display: flex;
}
.flex .sm-btn {
  font-size: 10px;
  padding: 0px 10px;
  margin: 0px;
}
</style>
